/**
 * Card #614: what a CONTACT file written in another language calls each
 * contact field, per language, keyed by the field's internal key (as
 * merchant/contact/csv/header/list sends it -- merch-backend
 * merchantUploadFile.controller.mjs headerList()). Separate from
 * HEADER_ALIASES_BY_LANGUAGE (csv-header-mapping.ts): contacts and items
 * have their own fields, and sharing one table would let an item alias
 * (e.g. item 'id') claim a column for the unrelated contact 'id' field.
 * Labels read from assets/i18n/<lang>.json at the contact-header cluster
 * (es.json ~1248-1288). Kept in its own file, next to csv-header-mapping.ts,
 * so the item and contact alias tables stay easy to find on their own.
 */
export const CONTACT_HEADER_ALIASES_BY_LANGUAGE: Record<string, Record<string, string[]>> = {
  es: {
    first_name: ['Nombre'],
    last_name: ['Apellido'],
    email: ['Correo electrónico', 'Correo'],
    organization: ['Organización'],
    gender: ['Género'],
    birth_date: ['Fecha de Nacimiento (dd/mm/aaaa)', 'Fecha de Nacimiento'],
    mark_contact_as_a_lead: ['Etiquetar contacto como prospecto'],
    source_of_contact: ['Fuente de contacto'],
    price_list: ['Lista de precios'],
    prefered_language: ['Idioma preferido'],
    audience: ['Audiencia'],
    country_code: ['Código de país'],
    name: ['Nombre del teléfono'],
    phone_number: ['Número de teléfono'],
    address_name: ['Nombre de la dirección'],
    house_number: ['Número de calle'],
    interior_number: ['Número interior'],
    street_name: ['Calle'],
    city: ['Ciudad'],
    state: ['Estado'],
    country: ['País'],
    postal_code: ['Código postal'],
    instagram_link: ['Enlace de Instagram'],
    facebook_link: ['Enlace de Facebook'],
    youtube_link: ['Enlace de YouTube'],
    linkedin_link: ['Enlace de LinkedIn'],
    website_link: ['Enlace sitio web'],
    tiktok_link: ['Enlace de TikTok'],
    behance_link: ['Enlace de Behance'],
    additional_date_title: ['Fechas Adicionales'],
  },
};
